import { useState } from "react";
import Navbar from "../components/Navbar";
import { sendTransaction } from "../services/utils";

const Send = () => {
    const [privateKey, setPrivateKey] = useState("");
    const [value, setValue] = useState("");
    const [recepientAddress, setRecepientAddress] = useState("");

    // Function to handle form input changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        // Update the corresponding state based on input name
        if (name === "privateKey") {
            setPrivateKey(value);
        } else if (name === "value") {
            setValue(value);
        } else if (name === "recepientAddress") {
            setRecepientAddress(value);
        }
    };

    const sendTx = async () => {
        try {
            const send = await sendTransaction(
                privateKey,
                recepientAddress,
                value
            );
            alert(send);
        } catch (error) {
            console.log(error);
            alert(JSON.parse(error).message);
        }
    };

    // Function to handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        // You can now access the form input values using state variables (privateKey, senderAddress, recepientAddress)
        console.log("Private Key:", privateKey);
        console.log("Sender Address:", value);
        console.log("Recepient Address:", recepientAddress);
        sendTx();
        // Perform any further actions (e.g., transaction submission) here
    };
    return (
        <>
            <div>
                <Navbar />
                <div className="flex flex-col gap-10 items-center mt-20">
                    <h1>Send your ETH</h1>
                    <div class="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-8">
                        <form class="space-y-6" onSubmit={handleSubmit}>
                            <h5 class="text-xl font-medium text-gray-900">
                                Fill details below to do transaction
                            </h5>
                            <div>
                                <label class="block mb-2 text-sm font-medium text-gray-900">
                                    Private Key
                                </label>
                                <input
                                    type="text"
                                    name="privateKey"
                                    id="privateKey"
                                    value={privateKey}
                                    onChange={handleChange}
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    placeholder="0x00...."
                                    required
                                />
                            </div>
                            <div>
                                <label class="block mb-2 text-sm font-medium text-gray-900">
                                    Recepient Wallet Address
                                </label>
                                <input
                                    type="text"
                                    name="recepientAddress"
                                    id="recepientAddress"
                                    value={recepientAddress}
                                    onChange={handleChange}
                                    placeholder="0x00...."
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    required
                                />
                            </div>
                            <div>
                                <label class="block mb-2 text-sm font-medium text-gray-900">
                                    ETH Value
                                </label>
                                <input
                                    type="text"
                                    name="value"
                                    id="value"
                                    value={value}
                                    onChange={handleChange}
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    placeholder="0x00...."
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                            >
                                Send!
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Send;
